import initialStepValidation from 'reducers/work-order/close-step-validation/initialStepValidation';

export default (state, orderId) => {
  const workOrderDetails = state.getIn([
    'workOrderDetails',
    orderId
  ]);

  const truckRollWasUnnecessary = workOrderDetails.getIn([
    'orderClose',
    'details',
    'truckRoll',
    'truckRollUnnecessary'
  ]);

  const truckRollComment = workOrderDetails.getIn([
    'orderClose',
    'details',
    'truckRoll',
    'truckRollCloseComment'
  ]);

  const submitPending = workOrderDetails.getIn([
    'orderClose',
    'details',
    'truckRoll',
    'submitPending'

  ]);
  const submitSuccess = workOrderDetails.getIn([
    'orderClose',
    'details',
    'truckRoll',
    'submitSuccess'
  ]);

  const submitAttempted = workOrderDetails.getIn([
    'orderClose',
    'details',
    'truckRoll',
    'submitAttempted'
  ]);

  const validSubmitAttempt = submitPending !== true && (submitSuccess === true || submitAttempted === true);

  const currentValidation = workOrderDetails.getIn([
    'orderClose',
    'details',
    'stepValidation'
  ]) || initialStepValidation;

  const isValid = truckRollWasUnnecessary !== true || (truckRollWasUnnecessary === true && truckRollComment && truckRollComment.length > 3 && validSubmitAttempt);

  return currentValidation
    .setIn(['truckRoll', 'isValid'], isValid);

};



// WEBPACK FOOTER //
// ./src/reducers/work-order/close-step-validation/truckRollValidator.js